import { Playroom } from "./playroom.model";


export class TimeSlotConfiguration {
  id: number;
  dateFrom: string;
  dateTo: string;
  startTime: string;
  endTime: string;
  birthdateDuration: string;
  pause: string;
  roomId: number;
  room: Playroom;

  birthdayZoneId: number | null;
  birthdayZoneName?: string;
  flexibleTherms:boolean;

  constructor() {
    this.id = null;
    this.dateFrom = '';
    this.dateTo = '';
    this.startTime = '';
    this.endTime = '';
    this.birthdateDuration = '';
    this.pause = '';
    this.roomId = null;
    this.room = null;

    this.birthdayZoneId = null;
    this.flexibleTherms=false;
  }
}
